import React from 'react';
import PropTypes from 'prop-types';
import ProgressGrid from '../ProgressGrid';
import useLearnerProgress from './useLearnerProgress';
import useChildLearnerProgress from './useChildLearnerProgress';

function ProgressGridContainer({ cohortId, deployment, selectedActivityId, ...props }) {
  const { deploymentId, activityId: rootActivityId } = deployment;
  const activityId = selectedActivityId || rootActivityId;

  const {
    loading,
    error,
    data: {
      enrollments,
      activity,
      childActivities,
    },
  } = useLearnerProgress(cohortId, deploymentId, activityId);

  const {
    errors,
    data: progressByChild,
  } = useChildLearnerProgress(cohortId, deploymentId, childActivities);

  if (error || errors) {
    // eslint-disable-next-line no-console
    console.error(error || errors);
    return null;
  }

  return (
    <ProgressGrid
      isLoading={loading || !activity}
      cohortId={cohortId}
      deploymentId={deploymentId}
      activity={activity}
      childActivities={childActivities}
      enrollments={enrollments}
      progressByChild={progressByChild}
      {...props}
    />
  );
}

ProgressGridContainer.propTypes = {
  cohortId: PropTypes.string.isRequired,
  deployment: PropTypes.object,
  selectedActivityId: PropTypes.string,
  navigationActions: PropTypes.element,
};

export default ProgressGridContainer;
